<template>
  <div data-test="border-style" class="border" :class="status"></div>
</template>

<script>
export default {
  name: "VBorderStyle",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.border {
  grid-column: 1;
  grid-row-start: 1;
  grid-row-end: 3;
  border: 2px solid var(--gray-300);
  margin-right: 0.5rem;
}

.err {
  border-color: var(--red-900);
}

.warning {
  border-color: var(--orange-700);
}

.success {
  border-color: var(--green-700);
}

.info {
  border-color: var(--blue-700);
}
</style>
